<template>
  <div>
    <p class="title">{{$t('set_color')}}</p>
    <cube-checker :options="options" type="radio" v-model="value">
      <cube-checker-item v-for="item in options" :key="item.value" :option="item">
        <div class="car-item">
          <img-v3 :src="item.car_icon_url" alt />
          <p>{{item.text}}</p>
        </div>
      </cube-checker-item>
    </cube-checker>
    <div class="set-btn">
      <div class="btn" @click="setColor">{{$t("set_color_btn")}}</div>
    </div>
  </div>
</template>
<script>
import { post } from "../../tools/request";
import { showLoadingToast, showAlertDialog, showToast } from "../../tools/Tip";
import { mapState } from "vuex";
export default {
  data() {
    return {
      options: [],
      value: (this.$route.params.configs || {}).value
    };
  },
  computed: {
    ...mapState(["_ticket"]),
    formItem() {
      return this.$route.params.configs || {};
    }
  },
  methods: {
    setColor() {
      if (!this.value) {
        return;
      }
      showLoadingToast(this);
      let up = new URLSearchParams(location.search);
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      // @20190213 支持任务中心,type|uid
      if (this.formItem.job_type) {
        up.append("job_type", this.formItem.job_type);
      }
      if (this.formItem.job_uid) {
        up.append("job_uid", this.formItem.job_uid);
      }
      up.set(this.formItem.key, this.value);
      let _url = process.env.ADD_AUDI_INFO;

      // @20210809 其他业务线特有参数和回调
      /*
        this.formItem.otherUp = {
          name: '其他项目名',
          url: '其他项目接口地址',
          up: '其他项目特殊传参',
        }
      */
      const otherUp = this.formItem.otherUp;
      if (otherUp) {
        otherUp.url && otherUp.url.set_car_color_url && (_url = otherUp.url.set_car_color_url);
        if (otherUp.up) {
          Object.keys(otherUp.up).forEach(item => {
            up.append(item, otherUp.up[item]);
          })
        }
      }
      post(_url, up)
        .then(data => {
          if (this.formItem.need_next === 1) {
            this.$router.replace({ name: 'photoProgress' })
          } else if (otherUp && otherUp.callback) {
            otherUp.callback(data);
          } else {
            this.$router.replace({ name: "home" });
          }
        })
        .catch(res => {
          showAlertDialog(this, res.errmsg)
        })
        .finally(() => this.toast.hide());
    }
  },
  created() {
    showLoadingToast(this);
    let up = new URLSearchParams(location.search);
    if (this._ticket) {
      up.set("ticket", this._ticket);
    }
    let _url = process.env.GET_COLORLIST;
    const otherUp = this.formItem.otherUp;
    if (otherUp) {
      otherUp.url && otherUp.url.get_car_color_url && (_url = otherUp.url.get_car_color_url);
    }
    post(_url, up)
      .then(data => {
        data.forEach(item => {
          item.text = item.color;
          item.value = item.color_enum;
        });
        this.options = data;
      })
      .catch(res => showAlertDialog(this, res.errmsg))
      .finally(() => this.toast.hide());
  }
};
</script>
<style lang="scss" scoped>
.title {
  color: #666;
  font-size: 0.3rem;
  text-align: center;
  padding: 0.32rem 0;
  background-color: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
}
.cube-checker {
  padding-bottom: 1.8rem;
}
.cube-checker-item {
  padding: 0;
  margin-right: 0;
  border-radius: 0;
}
.cube-checker-item_active {
  color: #ff7226;
  &:after {
    border-radius: 0;
    border: 2px solid #ff7226;
  }
}
.car-item {
  box-sizing: border-box;
  width: 2.5rem;
  height: 2.5rem;
  background: #ffffff;
  border-right: 1px solid rgba(0, 0, 0, 0.07);
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  img {
    width: 2rem;
    height: 1rem;
  }
  p {
    position: absolute;
    bottom: 0.32rem;
    font-size: 0.24rem;
    text-align: center;
    width: 100%;
  }
}
.set-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 1.62rem;
  width: 100%;
  box-sizing: border-box;
  background-color: #fff;
  box-shadow: 0 -2px 8px 0 rgba(0, 0, 0, 0.08);
  padding: 0.25rem;
  .btn {
    background: #ff7226;
    color: #fff;
    text-align: center;
    font-size: 0.38rem;
    height: 1.12rem;
    line-height: 1.12rem;
    border-radius: 2px;
  }
}
</style>


